import React, { useEffect, useState } from 'react'
import "./homemain.css"
import cat1 from "../../images/1.webp"
import cat2 from "../../images/sau1.webp"
import cat3 from "../../images/3.webp"
import cat4 from "../../images/5.webp"
import cat5 from "../../images/6.webp"
import cat6 from "../../images/1.webp"
import { LiaPeopleCarrySolid } from "react-icons/lia";
import CountUp from 'react-countup';
import { Link } from "react-router-dom";


import latest1 from "../../images/latest1.webp"
import latest2 from "../../images/latest2.webp"
import latest3 from "../../images/latest3.webp"
import latest4 from "../../images/latest4.webp"
import latest5 from "../../images/latest5.webp"
import latest6 from "../../images/latest6.webp"
import latest7 from "../../images/latest7.webp"
import latest8 from "../../images/latest8.webp"

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Homemain() {
    const [inView, setInView] = useState(false);
    // Intersection Observer callback to detect visibility
    const handleObserver = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                setInView(true);
                observer.unobserve(entry.target); // Stop observing once it's in view
            }
        });
    };

    useEffect(() => {
        const options = {
            root: null, // use the viewport as the root
            rootMargin: '0px', // margin around the root
            threshold: 0.5, // trigger when 50% of the element is visible
        };

        const observer = new IntersectionObserver(handleObserver, options);
        const target = document.querySelector('.countermaindiv'); // Target the section
        if (target) {
            observer.observe(target);
        }

        return () => {
            if (target) {
                observer.unobserve(target);
            }
        };
    }, []);


    var latestSettings = {
        arrows: true,
        autoplay: true,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <>
            <div className='catmaindiv'>

                <div className='catheadingdiv'>
                    <h2>Our Categories</h2>
                    <div className='catline'></div>
                </div>

                <div className='catimgmaindiv'>
                    <Link to="/wedding-categories">
                        <div className='catmaincat'>
                            <div className='catimgdiv'>
                                <img src={cat2} className='catimg' alt="catimg" />
                            </div>
                            <div className='catmaincatinner'>
                                <p>Wedding</p>
                            </div>
                        </div>
                    </Link>

                    <Link to="/shop">
                        <div className='catmaincat'>
                            <div className='catimgdiv'>
                                <img src={cat2} className='catimg' alt="catimg" />
                            </div>
                            <div className='catmaincatinner'>
                                <p>Anniversary</p>
                            </div>
                        </div>
                    </Link>

                    <Link to="/shop">
                        <div className='catmaincat'>
                            <div className='catimgdiv'>
                                <img src={cat2} className='catimg' alt="catimg" />
                            </div>
                            <div className='catmaincatinner'>
                                <p>Birthday </p>
                            </div>
                        </div>
                    </Link>

                    <Link to="/shop">
                        <div className='catmaincat'>
                            <div className='catimgdiv'>
                                <img src={cat2} className='catimg' alt="catimg" />
                            </div>
                            <div className='catmaincatinner'>
                                <p>Baby shower</p>
                            </div>
                        </div>
                    </Link>





                </div>
            </div>


            {/* latest product  */}
            <div className='latestmaindiv'>
                <div className='catheadingdiv'>
                    <h2>Latest Product's</h2>
                    <div className='catline'></div>
                </div>


                <div id='latestslider' className='latestslider'>
                    <Slider {...latestSettings}>
                        <div className='latestslidermaindiv'>
                            <img src={latest1} className='latestsliderimg' alt="sliderimg" />
                        </div>
                        <div className='latestslidermaindiv'>
                            <img src={latest2} className='latestsliderimg' alt="sliderimg" />
                        </div>
                        <div className='latestslidermaindiv'>
                            <img src={latest3} className='latestsliderimg' alt="sliderimg" />
                        </div>
                        <div className='latestslidermaindiv'>
                            <img src={latest4} className='latestsliderimg' alt="sliderimg" />
                        </div>
                        <div className='latestslidermaindiv'>
                            <img src={latest5} className='latestsliderimg' alt="sliderimg" />
                        </div>
                        <div className='latestslidermaindiv'>
                            <img src={latest6} className='latestsliderimg' alt="sliderimg" />
                        </div>
                        <div className='latestslidermaindiv'>
                            <img src={latest7} className='latestsliderimg' alt="sliderimg" />
                        </div>
                        <div className='latestslidermaindiv'>
                            <img src={latest8} className='latestsliderimg' alt="sliderimg" />
                        </div>
                    </Slider>
                </div>


                <div className='latestBtndiv'>
                    <button class="button">View All</button>
                </div>

            </div>


            {/* counter section  */}


            <div className="countermaindiv">
                <div className="counterinner">
                    <LiaPeopleCarrySolid className="customericon" />
                    <h3 className="counterNo">
                        {inView && <CountUp start={0} end={50} delay={1} duration={7} />}
                        {inView && '+'}
                    </h3>
                    <p className="counterName">Happy Customer's</p>
                </div>
                <div className="counterinner">
                    <LiaPeopleCarrySolid className="customericon" />
                    <h3 className="counterNo">
                        {inView && <CountUp start={0} end={100} delay={1} duration={7} />}
                        {inView && '+'}
                    </h3>
                    <p className="counterName">Project's Delivered</p>
                </div>
                <div className="counterinner">
                    <LiaPeopleCarrySolid className="customericon" />
                    <h3 className="counterNo">
                        {inView && <CountUp start={0} end={10} delay={1} duration={7} />}
                        {inView && '+'}
                    </h3>
                    <p className="counterName">Year's Of Experience</p>
                </div>
                {/* <div className="counterinner">
                    <LiaPeopleCarrySolid className="customericon" />
                    <h3 className="counterNo">
                        {inView && <CountUp start={0} end={100} delay={2} duration={7} />}
                        {inView && '+'}
                    </h3>
                    <p className="counterName">Happy Customer's</p>
                </div> */}
            </div>

        </>
    )
}

export default Homemain
